"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var PartnerPayDetailEditor = /** @class */ (function (_super) {
    __extends(PartnerPayDetailEditor, _super);
    function PartnerPayDetailEditor(props) {
        return _super.call(this, props) || this;
    }
    PartnerPayDetailEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AP = this.props.ListAffilatesPayoutsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_payouts: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    key: _item.key,
                    app_payout_id: _item.app_payout_id,
                    app_payout_title: _item.app_payout_title,
                    account: _item.account,
                    avail_payouts: []
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Детали выплат партнера", "Редактировать детали выплат"]);
                    _this.props.ListAffilatesPayoutsAvail.LoadData(_this.props.rootRecord.key);
                });
            }
        }
        else {
            this.setState({
                key: 0,
                app_payout_id: 0,
                app_payout_title: "",
                account: "",
                avail_payouts: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Детали выплат партнера", "Создать деталь выплат"]);
                _this.props.ListAffilatesPayoutsAvail.LoadData(_this.props.rootRecord.key);
            });
        }
        this.doReSetRules();
    };
    PartnerPayDetailEditor.prototype.componentWillUnmount = function () {
        this.props.ListAffilatesPayoutsAvail.UnSubscribe(this.SID_AP);
    };
    PartnerPayDetailEditor.prototype.doReSetRules = function () {
        this.setState({
            app_payout_rules: { isError: false },
            account_rules: { isError: false }
        });
    };
    PartnerPayDetailEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_payout_id <= 0) || (this.state.app_payout_title.length === 0)) {
            this.setState({ app_payout_rules: { isError: true, errorMessage: "Деталь выплат не выбрана!" } });
            return false;
        }
        if ((!this.state.account) || (this.state.account.length === 0)) {
            this.setState({ account_rules: { isError: true, errorMessage: "Аккаунт не заполнен!" } });
            return false;
        }
        return true;
    };
    PartnerPayDetailEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.state.key,
                app_payout_id: this.state.app_payout_id,
                account: this.state.account
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Деталь выплат партнера изменен!");
            });
        }
    };
    PartnerPayDetailEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_payout_id: this.state.app_payout_id,
                account: this.state.account,
                usr_partner_id: this.props.rootRecord.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Деталь выплат партнера добавлен!");
            });
        }
    };
    PartnerPayDetailEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PartnerPayDetailEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая деталь выплат партнера";
        }
        else {
            return "Изменить деталь выплат партнера";
        }
    };
    PartnerPayDetailEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 320 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип выплаты:", placeholder: "Выберите тип выплаты" }, value: { key: this.state.app_payout_id, value: this.state.app_payout_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_payout_id: newVal.key,
                        app_payout_title: newVal.value,
                        app_payout_rules: { isError: false }
                    });
                }, items: this.state.avail_payouts, required: true, rules: this.state.app_payout_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Аккаунт:", placeholder: "Введите аккаунт" }, value: this.state.account, onValueChanged: function (newVal) {
                    _this.setState({
                        account: newVal,
                        account_rules: { isError: false }
                    });
                }, required: true, rules: this.state.account_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PartnerPayDetailEditor;
}(React.Component));
exports.default = PartnerPayDetailEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/paydetail/PartnerPayDetailEditor.tsx
// module id = 2440
// module chunks = 0